import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppUserAuth, LoginModel } from '../Models/core';
import { Observable, of } from 'rxjs';
import { GlobalFunction } from '../shared/global-function';
import { IEmployee } from '../shared/models/employee/employee.model';
import { AppConfigService } from '../shared/services/app-config.service';
import { map, tap } from 'rxjs/operators';
import { AuthResponseData } from '../shared/models/authentication/auth-response-data';
import { ILicenseStatus } from 'src/app/shared/models/license/license-status.model';
import { Router } from '@angular/router';
import { ILicense } from '../shared/models/license/license.model';
import { LicenseService } from '../shared/services/license.service';
import * as moment from 'moment/moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { TutorialService } from '../shared/services/tutorial.service';
import { EmployeeService } from '../shared/services/employee.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService
{

    public licenses: ILicense;
    public employee: IEmployee;
    authResponseData: AuthResponseData;
    securityObject: AppUserAuth = new AppUserAuth();

    loginUser: LoginModel;
    users: IEmployee[];
    redirectUrl: string;

    displayExpiryWarning = false;
    displayExpiryError = false;
    licenseExpiryDate: Date;
    public licenseStatus: number;
    private licenseDaysShowBeforeExpired: number;
    //private licenseDaysShowBeforeExpired = 3000;
    private tokenUrl: string;
    public appointmentManagemantToken: any;
    translationObject: any;
    constructor(
        public http: HttpClient,
        private router: Router,
        //private licenseService:LicenseService,
        private snackBar: MatSnackBar,
        private translateService: TranslateService,
        private readonly tutorialService: TutorialService,
        private employeeService: EmployeeService,
    )
    {}


    getAllRecords(): Observable<IEmployee[]>
    {

        return this.http.get<IEmployee[]>(AppConfigService.appConfig.WebAPIServer + "/api/employee/get-all").pipe(
            tap(data => this.users = data),
        );
    }


    login(user: LoginModel): Observable<boolean>
    {
        let hdr = { 'Content-Type': 'application/json' };
        let options = { headers: hdr };
        this.tokenUrl = AppConfigService.appConfig.WebAPIServer + "/api/authentication/token";


        return this.http.post<AuthResponseData>(this.tokenUrl, JSON.stringify({ userName: user.Name, password: user.Password, isADUser: user.IsADUser }), options).pipe(
            map((data) =>
            {
                this.appointmentManagemantToken = data.appointmentManagemantToken;
                this.authResponseData = data;
                if (data.appointmentManagemantToken)
                {
                    setTimeout( () => {this.employeeService.get(this.authResponseData.userId).subscribe(data =>
                        {
                            this.employee = data;
                        });}, 500);

                    // data.expired
                    // get value from configuration
                    this.licenseDaysShowBeforeExpired = + AppConfigService.appConfig.licenseDaysShowBeforeExpired;

                    // the data data.expired only has a useful value for someone that can edit the company
                    //therefore we need anohter source
                    this.licenseStatus = ILicenseStatus.Valid;
                    let licenseExpiryDate = this.licenses.expiryDate;

                    if (GlobalFunction.isEmpty(licenseExpiryDate))
                    { // no license
                        this.licenseStatus = ILicenseStatus.NoLicense;
                    }
                    else
                    { // only a value for employee with authorization to edit company

                        // check against current date.
                        let dateNow = new Date();
                        //let testNowDate = '2023-08-26T00:00:00';
                        dateNow = new Date(dateNow);

                        // for no licences files this condition will be checked
                        let checkDefinedValue = licenseExpiryDate.substring(0, 10);

                        // copy to a local variable which will be read in the component class
                        this.licenseExpiryDate = new Date(licenseExpiryDate);

                        // a new object is required
                        let licenseDateShowWarning = new Date(this.licenseExpiryDate);
                        licenseDateShowWarning.setDate(licenseDateShowWarning.getDate() - this.licenseDaysShowBeforeExpired);


                        if (checkDefinedValue === undefined)
                        {
                            this.licenseStatus = ILicenseStatus.NoLicense;
                        }
                        else if (checkDefinedValue == '0001-01-01')
                        {
                            this.licenseStatus = ILicenseStatus.NoLicense;
                        }
                        else if (dateNow.getTime() > this.licenseExpiryDate.getTime())
                        {
                            this.licenseStatus = ILicenseStatus.IsExpired;
                        }
                        else if (dateNow.getTime() > licenseDateShowWarning.getTime())
                        {
                            this.licenseStatus = ILicenseStatus.WillExpire;
                        }
                        else
                        {
                            // not really required as we have also other users where an unvalid license has no consequences
                            this.licenseStatus = ILicenseStatus.Valid;
                        }

                    }

                    //   // TER-580 Teamleiter hat keinen Zugriff auf "Meine Termine"
                    //   // => teamleiter bekommt zugriff auf alle menüpunkte des Employees.
                    //   if (data.userRoles.findIndex( x => x == "TeamLeader") !== -1){    //TODO: Remove?
                    //     data.userRoles.push('Employee');
                    //   }

                    localStorage.setItem('AppointmentManagementUser', JSON.stringify({ userName: user.Name, appointmentManagemantToken: data.appointmentManagemantToken, expired: data.expired, userId: data.userId, userRoles: data.userRoles }));
                    this.tutorialService.getCompletedTutorials().subscribe(result => {
                        this.tutorialService.completedTutorials = result;
                    });
                    if (data.userRoles.indexOf('CompanySettings.Edit') == -1)
                    {
                        // no authorization to edit the company
                        if ((this.licenseStatus == ILicenseStatus.NoLicense) || (this.licenseStatus == ILicenseStatus.IsExpired))
                        {
                            return false;
                        }
                        else
                        {
                            this.router.navigate(["my-appointments"]);
                            return true;
                        }
                    }
                    // here only people that can edit the company
                    else if ((this.licenseStatus == ILicenseStatus.NoLicense) || (this.licenseStatus == ILicenseStatus.IsExpired))
                    {
                        // user must load a new license.  
                        this.router.navigate(["company-settings"]);
                    }
                    else
                    {
                        this.router.navigate(["my-appointments"]);
                    }

                    return true;
                }
                else
                {
                    // return false to indicate failed login
                    return false;
                }

            }));
    }


    logout(): void
    {
        this.router.navigate(['/']);
        this.resetSecurityObject();
    }

    isAuthenticated(): boolean
    {
        if (!GlobalFunction.isEmpty(localStorage.getItem('AppointmentManagementUser')))
        {
            this.authResponseData = JSON.parse(localStorage.getItem('AppointmentManagementUser'));

            if (this.authResponseData.appointmentManagemantToken !== "")
            {
                let sessionExpirationDate = moment(this.authResponseData.expired);
                let currentDate = moment(new Date());

                if(sessionExpirationDate >= currentDate)
                {
                    return true;
                }
            }
        }
        return false;
    }

    resetSecurityObject(): void
    {
        this.securityObject.userName = "";
        this.securityObject.securityToken = "";
        this.securityObject.isAuthenticated = false;
        this.securityObject.isAdmin = false;
        localStorage.removeItem("AppointmentManagementUser");
        //localStorage.clear();
    }




    UserTokenNotExpired(currentUser: string): boolean
    {
        if (currentUser === undefined || currentUser === null)
        {
            return false;
        }
  
        let currentUserObject: AuthResponseData = JSON.parse(currentUser);
        return true;
    }



    public getCurrentUserData(): AuthResponseData
    {
        const currentUser = this.getCurrentUser();
        return currentUser === null ? null : JSON.parse(currentUser);;
    }

    //Get the current user form the locla storage.
    public getCurrentUser(): any
    {
        return localStorage.getItem('AppointmentManagementUser');
    }

}